import { render, staticRenderFns } from "./starRating.vue?vue&type=template&id=7eabce0a&scoped=true"
import script from "./starRating.vue?vue&type=script&lang=js"
export * from "./starRating.vue?vue&type=script&lang=js"
import style0 from "./starRating.vue?vue&type=style&index=0&id=7eabce0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eabce0a",
  null
  
)

export default component.exports